import { Environment } from './types';
import { LOG_LEVEL } from '@app/shared/utils/log-level';

export const environment: Environment = {
  production: true,
  stage: 'prod',
  apiBaseUrl: 'https://api2-frontoffice.dentalxchange.com/v1',
  backofficeBaseUrl: 'https://backoffice.dentalxchange.com',
  apiIntegrationBaseUrl: 'https://api-frontoffice.dentalxchange.com/v2/integration',
  logLevel: LOG_LEVEL.ERROR,
  oauthAudience: 'front-office',
  oauth2ClientId: '3a748fb4-28c8-4df1-bd4b-789dd56ba808',
  oauth2PublicEndpoint: 'https://auth.dentalxchange.com',
  releaseTag: 'frontoffice-portal@1942',
  sentryDSN: 'https://a9780fcde77e4cad94c361cdf7158a86@sentry.prod.dentalxchange.com/73',
  sentryENV: 'prd',
  lightHouseWidget: {
    home: {
      page: 'category',
      pageId: 'pnduc1djle'
    },
    helpDocs: {
      newEligbility: {
        page: 'article',
        pageId: 'x12p3vpjoe'
      },
      payerCredentials: { page: 'article', pageId: '35sbwsvc2b' },
      erroredCheck: { page: 'article', pageId: '90mdx1lc10' },
      verifiedCheck: { page: 'article', pageId: 'mx8dt5po5n' }
    }
  },
  landingPageUrl: 'https://www.dentalxchange.com/product/lp/eligibility-ai-dde',
  userPilotAppToken: 'NX-928002a3',
  allowUserPilot: true
};
